import type { List } from './types'

/**
 * The order the Lists tab's chips run in: `lists.position`, ties by name,
 * archived lists left out. That is all.
 *
 * It used to be "pinned first, then Doing, Getting, Keeping", and a drag was
 * only allowed inside its own section. Doug wanted Kindred prep (a checklist,
 * so Doing) after DJs (a collection, so Keeping) and the rule forbade exactly
 * that: one value, `position`, was doing the job of "where this chip goes" and
 * the section was doing the job of "where it is allowed to go", and the
 * second quietly vetoed the first. There is one order now and it is the one
 * Doug sets by dragging or by Move to start / Move to end.
 *
 * `pinned` stays in the data and in the menu — Add to list
 * (`quickAddTargets`) still puts pinned lists first — but it does not affect
 * this row. Likewise `kind` no longer places a chip; it only picks its glyph.
 *
 * Here and not in `ListChips.tsx` so `test/chip-order.test.ts` can import it
 * without a JSX loader.
 */
export function chipOrder(lists: readonly List[]): List[] {
  return lists
    .filter(l => !l.archived_at)
    .sort((a, b) => a.position - b.position || (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
}
